// import React from 'react';
// import { Dialog, DialogContent, IconButton, Box, useTheme } from '@mui/material';
// import { Close } from '@mui/icons-material';
// import { Formik, Form } from 'formik';
// import * as Yup from 'yup';
// import CustomTextField from 'components/Fileds/CustomTextFiled';
// import CustomTypography from 'components/Fileds/CustomTypography';
// import CustomButton from 'components/Fileds/CustomButton';
// import "./style.css";

// const CollectionSchema = Yup.object().shape({
//   name: Yup.string().required('Collection Point Name is required'),
//   notes: Yup.string().required('Notes is required'),
// });

// const CollectionPointsModal = ({ open, onClose, initialData, onSubmit, loading }) => {
//   const theme = useTheme();
//   const isEdit = Boolean(initialData);
//   const title = isEdit ? 'Edit Collection Point' : 'Add Collection Point';

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="xs"
//       fullWidth
//       className="food-categoires-dialog"
//       PaperProps={{ sx: { borderRadius: '20px', padding: '10px', color: 'black' } }}
//     >
//       <Box className='d-flex align-items-center justify-content-center' sx={{ m: 0, p: 2 }}>
//         <CustomTypography
//           variant="h5"
//           label={title}
//           sx={{ fontSize: '24px', fontWeight: 700, color: theme.palette.typographyLabel.main, mb: 0 }}
//         />
//         <IconButton aria-label="close" onClick={onClose} className='close-icon-container'>
//           <Close />
//         </IconButton>
//       </Box>

//       <Formik
// initialValues={{
//      name: initialData?.name || '' ,
//      notes: initialData?.notes || '' 
// }}
//         validationSchema={CollectionSchema}
//         onSubmit={onSubmit}
//       >
//         {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
//           <Form>
//             <DialogContent className='food-categories-content'>
//                <Box sx={{mb: '20px'}}>
//                    <CustomTypography
//                        label="Collection Point Name"
//                        sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
//                    />
//                    <CustomTextField
//                        name="name"
//                        value={values.name}
//                        onChange={handleChange}
//                        onBlur={handleBlur}
//                        fullWidth
//                        placeholder="Enter Collection Point"
//                        error={touched.name && Boolean(errors.name)}
//                        helperText={touched.name && errors.name}
//                    />
//                </Box>

//   <Box>
//         <CustomTypography
//             label="Notes"
//             sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
//         />
//         <CustomTextField
//             name="notes"
//             value={values.notes}
//             onChange={handleChange}
//             onBlur={handleBlur}
//             fullWidth
//             placeholder="Enter Notes"
//             error={touched.notes && Boolean(errors.notes)}
//             helperText={touched.notes && errors.notes}
//         />
//   </Box>
//             </DialogContent>

//             <Box className='d-flex align-items-center justify-content-center' sx={{ p: 2 }}>
//               <CustomButton
//                 type='submit'
//                 fullWidth
//                 disabled={!values.name.trim() || isSubmitting || loading}
//                 sx={{ borderRadius: "10px", width: "220px", py: 2.1, height: '45px' }}
//               >
//                 {isEdit ? 'Update' : 'Save'}
//               </CustomButton>
//             </Box>
//           </Form>
//         )}
//       </Formik>
//     </Dialog>
//   );
// };

// export default CollectionPointsModal;





/* CollectionPointsModal.js */
import React from 'react';
import CustomTextField from 'components/Fileds/CustomTextFiled';
import CustomTypography from 'components/Fileds/CustomTypography';
import * as Yup from 'yup';
import GenericDialog from '../GenericDialog/GenericDialog';
import { Box, useTheme } from '@mui/material';
import CustomTextArea from 'components/Fileds/CustomTextArea';

const CollectionSchema = Yup.object().shape({
    name: Yup.string().required('Collection Point Name is required'),
    // notes: Yup.string().required('Notes is required'),
});

const CollectionPointsModal = ({ open, onClose, initialData, onSubmit, loading }) => {
    const isEdit = Boolean(initialData);
    const title = isEdit ? 'Edit Collection Point' : 'Add Collection Point';
    const theme = useTheme();
    return (
        <GenericDialog
            open={open}
            onClose={onClose}
            title={title}
            initialValues={{
                name: initialData?.name || '',
                notes: initialData?.notes || ''
            }}
            validationSchema={CollectionSchema}
            onSubmit={onSubmit}
            submitLabel={isEdit ? 'Update' : 'Save'}
            loading={loading}
            requiredFields={[ 'name' ]}
        >
            {({ values, errors, touched, handleChange, handleBlur }) => (
                <>
                    <Box sx={{ mb: '20px' }}>
                        <CustomTypography
                            label="Collection Point Name"
                            sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
                        />
                        <CustomTextField
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            placeholder="Enter Collection Point Name"
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                        />
                    </Box>
                    <Box>
                        <CustomTypography
                            label="Notes"
                            sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
                        />
                        {/* <CustomTextField
                            name="notes"
                            value={values.notes}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            multiline
                            maxRows={2}
                            height={"100%"}
                            placeholder="Enter Notes"
                            // error={touched.notes && Boolean(errors.notes)}
                            // helperText={touched.notes && errors.notes}
                        /> */}

                        <CustomTextArea
                            name="notes"
                            value={values.notes}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            multiline
                            rows={2}
                            // height={"100%"}
                            placeholder="Enter Notes"
                        
                        />
                    </Box>
                </>
            )}
        </GenericDialog>
    );
};

export default CollectionPointsModal;
